import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NotFound = () => /*#__PURE__*/_jsxs(ErrorMessage, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyPublic.notFoundPage.title"
  }),
  type: "notFound",
  children: [/*#__PURE__*/_jsx(Text, {
    as: "p",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyPublic.notFoundPage.message"
    })
  }), /*#__PURE__*/_jsx(Link, {
    to: "/",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyPublic.notFoundPage.backHome"
    })
  })]
});
export default NotFound;